import { useMutation } from 'react-query';
import { createRegisterResultAppendix } from 'apis/registerResult';

const useMutationCreateRegisterResultAppendix = () => {
  const { mutateAsync, ...rest } = useMutation(createRegisterResultAppendix);

  return {
    mutateAsync,
    ...rest,
  };
};

export default useMutationCreateRegisterResultAppendix;
